var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.1297 4.41748H2.55078","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.2669 6.43018L11.8753 11.7912C11.7944 12.9001 10.871 13.7594 9.75827 13.7594H5.92273C4.81068 13.7594 3.88666 12.9001 3.80572 11.7906L3.41406 6.43018","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.2546 4.41703L9.93274 2.83238C9.8393 2.48307 9.52237 2.24024 9.16122 2.24024H6.52372C6.16068 2.23899 5.8425 2.48183 5.74848 2.83238L5.42969 4.41703","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Delete.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Delete;

Delete.default = Delete;
